import React from 'react';
import { Link } from 'react-router-dom';
import '../css/RegistrationSuccess.css';

function RegistrationSuccess() {
  return (
    <div className="success-container">
      <div className="success-card">
        <h1 className="success-title">Registration Submitted</h1>
        <div className="success-icon">✓</div>
        <p className="success-message">
          Thank you for registering! Our project team will contact you soon with your credentials to login.
        </p>
        <Link to="/" className="home-link">Back to Home</Link>
      </div>
    </div>
  );
}

export default RegistrationSuccess;